// Enhanced Sticky Add to Cart functionality
(function() {
  'use strict';

  class EnhancedStickyCart {
    constructor() {
      this.stickyBar = document.querySelector('.enhanced-sticky-bar');
      this.productGallery = document.querySelector('.product-gallery');
      this.mainProductForm = document.querySelector('form[action*="/cart/add"]');
      this.cartDrawer = document.querySelector('cart-drawer');

      if (!this.stickyBar || !this.productGallery || !this.mainProductForm) {
        return;
      }

      this.init();
    }

    init() {
      this.setupQuantityControls();
      this.setupVariantSelector();
      this.setupVariantSelectorClickArea();
      this.setupScrollDetection();
      this.setupAddToCartButton();
      this.syncWithMainForm();
    }

    setupQuantityControls() {
      const minusButtons = this.stickyBar.querySelectorAll('.quantity-minus');
      const plusButtons = this.stickyBar.querySelectorAll('.quantity-plus');
      const quantityInputs = this.stickyBar.querySelectorAll('.sticky-quantity-input');
      const mainQuantityInput = this.mainProductForm.querySelector('input[name="quantity"]');

      if (quantityInputs.length === 0) return;

      document.addEventListener('click', (e) => {
        // Handle minus
        if (e.target.closest('.quantity-minus')) {
          const container = e.target.closest('.sticky-quantity-wrapper');
          if (!container) return;

          const quantityInputs = container.querySelectorAll('input[type="number"]');
          const mainQuantityInput = document.querySelector('.sticky-quantity-input');
          const currentValue = parseInt(quantityInputs[0].value) || 1;
          if (currentValue > 1) {
            const newValue = currentValue - 1;
            quantityInputs.forEach(input => input.value = newValue);
            if (mainQuantityInput) mainQuantityInput.value = newValue;
          }
        }

        // Handle plus
        if (e.target.closest('.quantity-plus')) {
          const container = e.target.closest('.sticky-quantity-wrapper');
          if (!container) return;

          const quantityInputs = container.querySelectorAll('input[type="number"]');
          const mainQuantityInput = document.querySelector('.sticky-quantity-input');
          const currentValue = parseInt(quantityInputs[0].value) || 1;
          const newValue = currentValue + 1;
          quantityInputs.forEach(input => input.value = newValue);
          if (mainQuantityInput) mainQuantityInput.value = newValue;
        }
      });

      // Handle direct input
      document.addEventListener('change', (e) => {
        const input = e.target.closest('.sticky-quantity-wrapper input[type="number"]');
        if (input) {
          const container = input.closest('.sticky-quantity-wrapper');
          const quantityInputs = container.querySelectorAll('input[type="number"]');
          const mainQuantityInput = document.querySelector('.sticky-quantity-input');
          const value = Math.max(1, parseInt(input.value) || 1);
          quantityInputs.forEach(i => i.value = value);
          if (mainQuantityInput) mainQuantityInput.value = value;
        }
      });

      // Sync with main form quantity changes
      if (mainQuantityInput) {
        mainQuantityInput.addEventListener('change', () => {
          quantityInputs.forEach(input => input.value = mainQuantityInput.value);
        });
      }
    }

    setupVariantSelector() {
      const mobileVariantSelect = this.stickyBar.querySelector('.sticky-variant-select');
      const desktopVariantSelect = this.stickyBar.querySelector('.sticky-variant-select-desktop');
      const variantSelectors = [mobileVariantSelect, desktopVariantSelect].filter(Boolean);
      const mainVariantInputs = this.mainProductForm.querySelectorAll('input[name="id"], select[name="id"]');
      const addToCartButton = this.stickyBar.querySelector('button[type="submit"]');
      const priceDisplay = this.stickyBar.querySelector('.sticky-price');

      if (variantSelectors.length === 0) return;

      document.addEventListener('change', (e) => {
        if (e.target.matches('select.sticky-variant-select, select.sticky-variant-select-desktop')) {
          const variantSelect = e.target;
          const selectedVariantId = variantSelect.value;
          const selectedOption = variantSelect.options[variantSelect.selectedIndex];
          const isAvailable = selectedOption.dataset.available === 'true';
          const price = selectedOption.dataset.price;
          const comparePrice = selectedOption.dataset.comparePrice;

         
          variantSelectors.forEach(otherSelect => {
            if (otherSelect !== variantSelect) {
              otherSelect.value = selectedVariantId;
            }
          });


          mainVariantInputs.forEach(input => {
            if (input.type === 'hidden' || input.tagName === 'SELECT') {
              input.value = selectedVariantId;
            }
          });

          const priceDisplay = document.querySelector('.sticky-price');
          this.updateButtonState(addToCartButton, selectedVariantId, isAvailable);
          this.updatePriceDisplay(priceDisplay, price, comparePrice);

          const changeEvent = new Event('change', { bubbles: true });
          mainVariantInputs[0]?.dispatchEvent(changeEvent);
        }

        if (Array.from(mainVariantInputs).includes(e.target)) {
          const input = e.target;
          if (input.value) {
            variantSelectors.forEach(variantSelect => {
              variantSelect.value = input.value;
              const selectedOption = variantSelect.options[variantSelect.selectedIndex];
              if (selectedOption) {
                const isAvailable = selectedOption.dataset.available === 'true';
                const price = selectedOption.dataset.price;
                const comparePrice = selectedOption.dataset.comparePrice;
                
                this.updateButtonState(addToCartButton, input.value, isAvailable);
                this.updatePriceDisplay(priceDisplay, price, comparePrice);
              }
            });
          }
        }
      });

      // Initial state check
      const firstSelector = variantSelectors[0];
      if (firstSelector && firstSelector.value) {
        const selectedOption = firstSelector.options[firstSelector.selectedIndex];
        const isAvailable = selectedOption.dataset.available === 'true';
        this.updateButtonState(addToCartButton, firstSelector.value, isAvailable);
      } else {
        // No variant selected, disable button
        this.updateButtonState(addToCartButton, null, false);
      }
    }

    setupVariantSelectorClickArea() {
      // Find all variant selector containers
      const variantContainers = this.stickyBar.querySelectorAll('.sticky-variant-selector, .sticky-variant-selector-desktop');

      variantContainers.forEach(container => {
        // Ensure select is never disabled and all options are selectable
        const select = container.querySelector('select');
        if (select) {
          select.disabled = false;
          select.removeAttribute('disabled');
          select.style.pointerEvents = 'auto';
          select.style.opacity = '1';
          select.style.cursor = 'pointer';

          // Enable all options - remove disabled attribute from all options
          const options = select.querySelectorAll('option');
          options.forEach(option => {
            option.removeAttribute('disabled');
          });
        }

        // Add visual feedback on hover only
        container.addEventListener('mouseenter', () => {
          container.style.opacity = '0.8';
        });

        container.addEventListener('mouseleave', () => {
          container.style.opacity = '1';
        });
      });
    }

    updateButtonState(button, variantId, isAvailable) {
      if (!button) return;

      const buttonText = button.querySelector('.button-text');
      if (!buttonText) return;

      // Get translations from button data attributes (set by Liquid)
      const addToCartText = this.getTranslation('add_to_cart_button');
      const soldOutText = this.getTranslation('sold_out_button');
      const chooseOptionsText = this.getTranslation('choose_options');

      if (!variantId) {
        button.disabled = true;
        button.classList.add('button--disabled');
        buttonText.textContent = chooseOptionsText;
      } else if (!isAvailable) {
        button.disabled = true;
        button.classList.add('button--disabled');
        buttonText.textContent = soldOutText;
      } else {
        button.disabled = false;
        button.classList.remove('button--disabled');
        buttonText.textContent = addToCartText;
      }
    }

    getTranslation(key) {
      // Get translation from button data attributes (set by Liquid templates)
      const stickyButton = this.stickyBar.querySelector('button[type="submit"]');
      if (stickyButton) {
        const dataKey = `data-${key.replace(/[_]/g, '-')}-text`;
        const translation = stickyButton.getAttribute(dataKey);
        if (translation && translation.trim()) {
          return translation.trim();
        }
      }

      // Fallback: try to get from main form button for add to cart only
      if (key === 'add_to_cart_button') {
        const mainForm = this.mainProductForm;
        if (mainForm) {
          const submitButton = mainForm.querySelector('button[type="submit"]');
          if (submitButton) {
            const originalText = submitButton.textContent.trim();
            if (originalText &&
                !originalText.toLowerCase().includes('sold') &&
                !originalText.toLowerCase().includes('agotado') &&
                !originalText.toLowerCase().includes('unavailable') &&
                !originalText.toLowerCase().includes('choose')) {
              return originalText;
            }
          }
        }
      }

      // Final fallback: try to get from any data attribute that matches
      if (stickyButton) {
        // Try common variations of the key
        const possibleKeys = [
          `data-${key.replace(/[_]/g, '-')}-text`,
          `data-${key}-text`,
          'data-add-to-cart-text' // always fallback to add to cart
        ];

        for (const possibleKey of possibleKeys) {
          const fallbackText = stickyButton.getAttribute(possibleKey);
          if (fallbackText && fallbackText.trim()) {
            return fallbackText.trim();
          }
        }
      }

      // Ultimate fallback - should rarely be reached
      console.warn(`Translation not found for key: ${key}`);
      return 'Add to cart';
    }

    updatePriceDisplay(priceElement, price, comparePrice) {
      if (!priceElement || !price) return;

      let priceHTML = '';

      if (comparePrice) {
        priceHTML = `<span class="price-compare"><s>${comparePrice}€</s></span> <span class="price-current">${price}€</span>`;
      } else {
        priceHTML = `<span class="price-current">${price}€</span>`;
      }

      priceElement.innerHTML = priceHTML;
    }

    setupScrollDetection() {
      let ticking = false;

      const updateStickyBarVisibility = () => {
        // Check if we're on mobile
        const isMobile = window.innerWidth <= 699;

        if (isMobile) {
          // On mobile, always show sticky bar
          this.stickyBar.classList.add('is-visible');
          document.body.classList.add('sticky-cart-visible');
        } else {
          // On desktop, use scroll-based logic
          const galleryRect = this.productGallery.getBoundingClientRect();
          const formRect = this.mainProductForm.getBoundingClientRect();

          // Show sticky bar when:
          // 1. Product gallery is scrolled past (top is negative)
          // 2. Main form is not visible (completely above viewport)
          const shouldShow = galleryRect.bottom < 100 && formRect.bottom < 0;

          this.stickyBar.classList.toggle('is-visible', shouldShow);
          // Don't add sticky-cart-visible class on desktop as we don't hide original buttons
        }

        ticking = false;
      };

      const onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(updateStickyBarVisibility);
          ticking = true;
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      // Initial check
      updateStickyBarVisibility();

      // Also handle resize events to update mobile/desktop logic
      window.addEventListener('resize', () => {
        if (!ticking) {
          requestAnimationFrame(updateStickyBarVisibility);
          ticking = true;
        }
      }, { passive: true });
    }

    setupAddToCartButton() {
      const addToCartButton = this.stickyBar.querySelector('button[type="submit"]');

      if (!addToCartButton) return;

      addToCartButton.addEventListener('click', async (e) => {
        e.preventDefault();

        // Get form data
        const formData = new FormData(this.mainProductForm);

        // Add loading state
        addToCartButton.classList.add('loading');
        addToCartButton.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: formData.get('id'),
              quantity: formData.get('quantity') || 1,
              properties: this.getFormProperties(formData)
            })
          });

          if (response.ok) {
            const result = await response.json();
            this.showSuccess();
            this.openCartDrawer();
          } else {
            const error = await response.json();
            this.showError(error.message || 'Error adding to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          this.showError('Error adding to cart');
        } finally {
          // Remove loading state
          addToCartButton.classList.remove('loading');
          addToCartButton.disabled = false;
        }
      });
    }

    getFormProperties(formData) {
      const properties = {};
      for (let [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          const propName = key.match(/properties\[(.*)\]/)[1];
          properties[propName] = value;
        }
      }
      return properties;
    }

    showSuccess() {
      // Create a temporary success notification
      const notification = document.createElement('div');
      notification.className = 'sticky-cart-notification success';
      notification.innerHTML = `
        <div class="notification-content">
          Added to cart!
        </div>
      `;

      document.body.appendChild(notification);

      // Add styles
      Object.assign(notification.style, {
        position: 'fixed',
        top: '20px',
        right: '20px',
        background: '#10b981',
        color: 'white',
        padding: '12px 16px',
        borderRadius: '8px',
        zIndex: '9999',
        transform: 'translateX(100%)',
        transition: 'transform 0.3s ease'
      });

      // Animate in
      setTimeout(() => {
        notification.style.transform = 'translateX(0)';
      }, 10);

      // Remove after 3 seconds
      setTimeout(() => {
        notification.style.transform = 'translateX(100%)';
        setTimeout(() => {
          notification.remove();
        }, 300);
      }, 3000);
    }

    showError(message) {
      console.error('Cart error:', message);
      // You could implement error notification similar to showSuccess
    }

    openCartDrawer() {
      // Try to open cart drawer if it exists
      if (this.cartDrawer && typeof this.cartDrawer.open === 'function') {
        this.cartDrawer.open();
      } else {
        // Fallback: trigger cart drawer open event
        const cartToggle = document.querySelector('[aria-controls="cart-drawer"]');
        if (cartToggle) {
          cartToggle.click();
        }
      }
    }

    syncWithMainForm() {
      // Keep sticky bar in sync with main product form changes
      const observer = new MutationObserver(() => {
        // Re-sync form values when the main form changes
        const mainVariantInput = this.mainProductForm.querySelector('input[name="id"]');
        const stickyVariantSelect = this.stickyBar.querySelector('.sticky-variant-select');

        if (mainVariantInput && stickyVariantSelect) {
          stickyVariantSelect.value = mainVariantInput.value;
        }
      });

      observer.observe(this.mainProductForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new EnhancedStickyCart();
    });
  } else {
    new EnhancedStickyCart();
  }

})();